import Autorenew from '@mui/icons-material/Autorenew';
import DoNotDisturbOn from '@mui/icons-material/DoNotDisturbOn';
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';

import { useGetInstancesQuery } from '@api/connectInstance';
import { useGetMyProfileQuery } from '@api/user';
import { CustomPopover } from '@components/CustomPopover';
import { usePopover } from '@hooks/usePopover';

import { setSelectInstallationDialog } from '@redux/slices/app';
import { useDispatch } from '@redux/store';

import { sxBadge, sxIconButton, sxPopoverContent } from './styles';

const ReceivedConnectPopover: FC = () => {
  const dispatch = useDispatch();
  const popover = usePopover<HTMLButtonElement>();
  const { data: instances = [] } = useGetInstancesQuery();
  const { data: currentUser } = useGetMyProfileQuery();

  const currentUserId = currentUser?.id ?? null;
  const connectedInstance = instances.find((inst) => inst?.connectedUserId && inst.connectedUserId === currentUserId);
  const isConnected = Boolean(connectedInstance);
  const showBadge = !isConnected && instances.length > 0;

  const handleChangeConnection = () => {
    popover.onClose();
    dispatch(setSelectInstallationDialog({ open: true }));
  };

  const connectionLabel =
    isConnected && connectedInstance
      ? `Connected to ${connectedInstance.name || `Installation #${connectedInstance.id}`}`
      : "You're not connected to an installation of Received Connect.";

  return (
    <>
      <Tooltip title="Received Connect" arrow>
        <Box component="span" position="relative" display="inline-flex">
          <IconButton onClick={popover.onOpen} sx={sxIconButton} aria-label="Received Connect">
            <Autorenew sx={{ width: 20, height: 20 }} />
          </IconButton>
          {showBadge && <DoNotDisturbOn sx={sxBadge} />}
        </Box>
      </Tooltip>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        anchorEl={popover.anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={sxPopoverContent}>
          <Typography variant="subtitle1" gutterBottom>
            Received Connect
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {connectionLabel}
          </Typography>
          <Button variant={isConnected ? 'outlined' : 'soft'} fullWidth onClick={handleChangeConnection}>
            {isConnected ? 'Change Connection' : 'Select Installation'}
          </Button>
        </Box>
      </CustomPopover>
    </>
  );
};

export default ReceivedConnectPopover;
